export const formatDisplayDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    
    // Create date formatter for French locale
    const formatter = new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
    
    // Format and replace default separators with desired ones
    return formatter.format(date)
        .replace(/\//g, '/')  // Replace any forward slashes with dashes
        .replace(', ', ' à ') // Replace comma and space with ' à '
        .replace(':', 'h');   // Replace : with h
};